import React from 'react';
import { useSelector } from 'react-redux';
import { getPersonalizedSubscriptionData } from 'logic/store/elitetutor/elitetutor.selectors';
import { translate, translationKeys } from 'logic/translations/translations.service';
import { colors } from 'styles/colors';
import { useParams } from 'react-router-dom';
import { SummaryRow, SummaryValueSpan } from '../styles/summary-styles';

export const CouponDiscount = ({
  couponDiscountText,
  absoluteNegativeCouponDiscountWithUnit,
}: {
  couponDiscountText: string | null;
  absoluteNegativeCouponDiscountWithUnit: string | null;
}) => {
  const { token: personalizedSubscriptionToken } = useParams<{ token: string }>();
  const personalizedSubscriptionData = useSelector(getPersonalizedSubscriptionData);

  if (!personalizedSubscriptionToken || !personalizedSubscriptionData) {
    return null;
  }

  return (
    <>
      {personalizedSubscriptionData.discount && couponDiscountText && (
        <SummaryRow style={{ color: colors.green, fontWeight: 700, fontSize: 18 }}>
          <span>
            {translate(translationKeys.pricing.selection.summary.couponDiscount)}{' '}
            {couponDiscountText}
          </span>
          <SummaryValueSpan>{absoluteNegativeCouponDiscountWithUnit}</SummaryValueSpan>
        </SummaryRow>
      )}
      {
        // couponCode exists but discount is not returned by endpoint -> Coupon cannot be interpreted by our FE calculation
        personalizedSubscriptionData.personalizedSubscription?.couponCode &&
          !personalizedSubscriptionData.discount && (
            <SummaryRow style={{ color: colors.green, fontWeight: 700, fontSize: 18 }}>
              <span>{translate(translationKeys.pricing.couponPriceOnNextPage)}</span>
            </SummaryRow>
          )
      }
    </>
  );
};
